const clean = (value) => String(value || "").trim();

export const formatCustomerAddressParts = (customer = {}) => {
  const safeCustomer = customer || {};
  const address = clean(safeCustomer.address);
  const city = clean(safeCustomer.city);
  const state = clean(safeCustomer.state);
  const zip = clean(safeCustomer.zip);

  const locality = [city, state].filter(Boolean).join(", ");
  const localityWithZip = [locality, zip].filter(Boolean).join(" ");

  return [address, localityWithZip].filter(Boolean);
};

export const formatCustomerAddress = (customer = {}, multiline = false) => {
  const parts = formatCustomerAddressParts(customer);
  return multiline ? parts.join("\n") : parts.join(", ");
};
